import { render, staticRenderFns } from "./RelatorioNFRecebidaView.vue?vue&type=template&id=38b5b0da&scoped=true"
import script from "./RelatorioNFRecebidaView.vue?vue&type=script&lang=js"
export * from "./RelatorioNFRecebidaView.vue?vue&type=script&lang=js"
import style0 from "./RelatorioNFRecebidaView.vue?vue&type=style&index=0&id=38b5b0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b5b0da",
  null
  
)

export default component.exports